import axios from "axios";
import Auth from "../../services/Auth/Auth";
import {
  API_TIMEOUT,
  API_TIMEOUT_FILE,
  API_URL,
} from "../constants/api.constants";

const API = {
  async get({ endpoint, isWithoutAuth, params }) {
    var config = {
      method: "get",
      url: `${API_URL}${endpoint}`,
      headers: {
        Accept: "application/json",
      },
      timeout: API_TIMEOUT,
      params: params
    };

    if (!isWithoutAuth) {
      config.headers["Authorization"] = `Token ${
        Auth.getCurrentUser()["token"]
      }`;
    }

    var response = await axios
      .request(config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });

    if (!Auth.tokenIsExpired()) {
      Auth.refreshTokenExpiration();
    }

    return response;
  },
  async post({ endpoint, data }) {
    let timeout = API_TIMEOUT;
    if (endpoint && endpoint.includes("file/")) {
      timeout = API_TIMEOUT_FILE;
    }

    var config = {
      method: "post",
      url: `${API_URL}${endpoint}`,
      headers: {
        Accept: "application/json",
        Authorization: "Token " + Auth.getCurrentUser()["token"],
        "Content-Type": "application/json",
      },
      data: JSON.stringify(data),
      timeout: timeout,
    };

    var response = await axios
      .request(config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });

    if (!Auth.tokenIsExpired()) {
      Auth.refreshTokenExpiration();
    }

    return response;
  },
  async put({ endpoint, data }) {
    let config = {
      method: "put",
      url: `${API_URL}${endpoint}`,
      headers: {
        Accept: "application/json",
        Authorization: "Token " + Auth.getCurrentUser()["token"],
        "Content-Type": "application/json",
      },
      data: JSON.stringify(data),
      timeout: API_TIMEOUT,
    };

    var response = await axios
      .request(config)
      .then((response) => response)
      .catch((error) => error.response);

    if (!Auth.tokenIsExpired()) {
      Auth.refreshTokenExpiration();
    }

    return response;
  },
  async delete({ endpoint }) {
    let config = {
      method: "delete",
      url: `${API_URL}${endpoint}`,
      headers: {
        Accept: "application/json",
        Authorization: "Token " + Auth.getCurrentUser()["token"],
      },
      timeout: API_TIMEOUT,
    };

    var response = await axios
      .request(config)
      .then((response) => response)
      .catch((error) => error.response);

    if (!Auth.tokenIsExpired()) {
      Auth.refreshTokenExpiration();
    }

    return response;
  },
  async getFile({ endpoint, data }) {
    var config = {
      url: `${API_URL}${endpoint}`,
      responseType: "blob",
      headers: {
        Authorization: "Token " + Auth.getCurrentUser()["token"],
      },
      timeout: API_TIMEOUT_FILE,
    };

    if (data) {
      config.method = "post";
      config.headers["Content-Type"] = "application/json";
      config.data = JSON.stringify(data);
    } else {
      config.method = "get";
    }

    var response = await axios
      .request(config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          error.response = error;
        }
        return error.response;
      });

    if (!Auth.tokenIsExpired()) {
      Auth.refreshTokenExpiration();
    }

    return response;
  },
};

export default API;
